class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if ((!this.contains(event.target) || event.target.classList.contains('modal-overlay')) && !event.target.parentElement.classList.contains('search-filters__list')) this.close(false);
  }

  open(event) {
    if (event.target?.closest('.header__box')) {
      event.target.closest('.header__box').style.position = 'static';
    }
    if (event.target.closest('.bottom-island__search-btn') || event.target.closest('.menu-drawer__open-search-container')) {
      this.detailsContainer.setAttribute('open', true);
    }
    else {
      this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
      event.target.closest('details').setAttribute('open', true);

      //prevent header to hide when opening the search modal
      document.querySelector('sticky-header').preventHide = true;
    }

    this.querySelectorAll('.modal-overlay').forEach((overlay) => {
      overlay.addEventListener('click', this.close.bind(this));
    });
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(event, focusToggle = true) {
    if (event.target?.closest('.header__box')) {
      event.target.closest('.header__box').removeAttribute('style')
    }
    document.querySelector('.header__box.header__box--right').removeAttribute('style')

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.querySelector('header .header__box--right').classList.remove('search-modal--open');

    //allow header to hide after search bar is closed
    document.querySelector('sticky-header').preventHide = false;

  }
}

customElements.define('details-modal', DetailsModal);